var map = {
	"./65a7ca09-ee78-4b03-9d0a-6c29c38e2f2f-1684906228174.jpg": 4739,
	"./da221dc0-bc09-4e42-ac09-1de231e1ed89-1684905577894.jpg": 3738,
	"./sample": 7968,
	"./sample.jsx": 7968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4554;